import { useGetResolved, useGetResolvedWithInfiniteQuery } from './useGetResolved'

export const tasks = {
  getResolved: useGetResolved,
  getResolvedInfinite: useGetResolvedWithInfiniteQuery,
}
